/**
 * @file: useShowsAiCreditBalance.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { useCurrentUser } from '@euler/app/flows/auth/context';

/**
 * Whether the app shows the store's AI credit balance: the workshop line
 * buys credits on their own, so it sees them; the `ai` and `full` lines
 * see none until the owner decides how they should.
 */
export function useShowsAiCreditBalance(): boolean {
  const line = useCurrentUser()?.store.editionProductLine;
  return line == null || line === 'workshop';
}
